import { useEffect } from 'react';
import { appOverlayDisplayConfig } from '../actions';
import { useAppDispatch } from '../../hooks/redux';
import { getOverlayDisplayConfig } from '../utils/getOverlayDisplayConfig';
import { useOverlayDisplayLogic } from './useOverlayDisplayLogic';
export function useUpdateAppOverlayConfigState() {
  const dispatch = useAppDispatch();
  const {
    isOverlayConfigStateInit,
    isTopLevelWindow
  } = useOverlayDisplayLogic();
  useEffect(() => {
    if (!isTopLevelWindow || isOverlayConfigStateInit) {
      return;
    }

    // The display config for overlays is determined and communicated to Nav by individual apps
    const overlayConfig = getOverlayDisplayConfig();
    const id = setTimeout(() => {
      dispatch(appOverlayDisplayConfig(overlayConfig));
      clearTimeout(id);
    }, 0);
  }, [dispatch, isOverlayConfigStateInit, isTopLevelWindow]);
}